import { getDefaultDateRange } from 'helpers/date';
import { IViewPreferences, IDonationListPreferences } from 'store/viewPreferences/types';

/**
 * Safely reads donation list preferences from storage with fallback defaults.
 * Handles parsing errors and missing values gracefully.
 */
const hydrateFromStorage = (prefix: string): IDonationListPreferences => {
  const sortState = (() => {
    try {
      const stored = sessionStorage.getItem(`${prefix}SortState`);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })();

  const searchString = sessionStorage.getItem(`${prefix}SearchString`);

  const columnVisibility = (() => {
    try {
      return JSON.parse(
        sessionStorage.getItem(`${prefix}ColumnVisibility`) ||
          localStorage.getItem(`${prefix}DefaultColumnVisibility`) ||
          '{}'
      );
    } catch {
      return {};
    }
  })();

  return {
    sortState,
    searchString,
    columnVisibility,
  };
};

export const initialState: IViewPreferences = {
  dates: getDefaultDateRange(),
  donationListPreferences: hydrateFromStorage('donationList'),
  recipientDonationListPreferences: hydrateFromStorage('recipientDonationList'),
};
